import React from 'react';

function AboutSection() {
    return (
        <section className="relative mb-32">
            <div className="md:absolute md:left-[calc(-50vw+22rem)] md:top-0 md:w-[calc(50vw-22rem)] md:text-center mb-6 md:mb-0">
                <h2 className="text-base font-medium text-[#777777] lowercase">about</h2>
            </div>
            <div className="space-y-12">
                <div className="space-y-6">
                    <p className="text-base leading-normal text-[#777777] font-normal">
                        Building realtime interactive models for avatars
                    </p>
                    <p className="text-base leading-normal text-[#1C1C1C] font-normal">
                        Canopy Labs is building realtime interactive models for avatars. We think this is one of the most important open problems today. In the future billions of people will interact with these avatars. Here are some of the ways we think society will change:
                    </p>
                    <ol className="list-decimal list-outside pl-5 space-y-3 text-base leading-normal text-[#1C1C1C] font-normal">
                        <li>A billion children will be given personalised authentic educational experiences</li>
                        <li>Every corporate call will have an avatar, that can add information, contribute superhumanly to meetings naturally</li>
                        <li>A meaningful fraction of the internet will adopt AI native interfaces for more immersive experiences</li>
                    </ol>
                </div>

                {/* Main Image */}
                <div className="w-full rounded-sm overflow-hidden group cursor-pointer">
                    <img
                        src="/landingpng.png"
                        alt="Canopy Labs Workspace"
                        className="w-full h-auto object-cover"
                    />
                </div>
            </div>
        </section>
    );
}

export default AboutSection;
